import { InjectionToken } from '@angular/core';
import { ServiceRepository } from '../repositories/service.repository';

export const SERVICE_REPOSITORY = new InjectionToken<ServiceRepository>(
  'SERVICE_REPOSITORY'
);
